import { FlagsManager, type AddFlagProps, type Flag } from '@databases/flags-types';

/**
 * A default implementation of the FlagsManager contract.
 * This is designed for use with `<DefaultFlagGroup />`.
 */
export class LocalFlagsManager extends FlagsManager {
  addFlag(flagProps: AddFlagProps) {
    const newFlagId = this.flags.data.length + 1;
    const newFlag: Flag = {
      id: newFlagId,
      ...flagProps
    };

    this.flags.data.unshift(newFlag);
  }

  handleFlagDismiss(flagId: number | string) {
    this.flags.data = this.flags.data.filter((flag) => flag.id !== flagId);
  }

  clearFlags() {
    this.flags.data = [];
  }

  // Migration: Flags manager v2 methods
  showFlag() {}
  hideFlag() {}
  hideAllFlags() {}
}
